import { useCrmCompanyQuery } from '@/gql/generated';

export const useCrmCompany = (whmcsId: number | undefined) => {
  const { data, isLoading, refetch, isPending } = useCrmCompanyQuery(
    { input_obj: { whmcs_id: whmcsId! } },
    {
      enabled: !!whmcsId,
    },
  );

  return { data, isLoading, refetch, isPending };
};
